"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * File: TermsDialog.js
 * Project: tsys-online-payments
 *
 * Created by Jed Dumire on 08/06/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Fullscreen dialog to display online payment terms of service
 */
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    appBar: {
      position: "relative"
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1
    }
  };
});

var TermsDialog = function TermsDialog(_ref) {
  var handleAccept = _ref.handleAccept,
      handleClose = _ref.handleClose,
      open = _ref.open,
      terms = _ref.terms;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    fullScreen: true,
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "print-hide"
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.appBar
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    edge: "start",
    onClick: handleClose,
    color: "inherit"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    className: classes.title
  }, "Online Payment Terms of Service"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: function onClick() {
      return window.print();
    },
    color: "inherit"
  }, "Print"))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: "print-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: terms
    }
  })), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    onClick: handleAccept,
    color: "primary"
  }, "Accept"))));
};

TermsDialog.propTypes = {
  handleAccept: _propTypes.default.func.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool,
  terms: _propTypes.default.string.isRequired
};
var _default = TermsDialog;
exports.default = _default;